const $ = require('jquery');
import LookupTable from "../../components/lookupTable/index";
import run from '../../utilities/run';
import {isPresent} from "../../utilities/general";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT,SUCCESS_MODAL_TIMEOUT} from "../../constants";
import render from "../../utilities/render";
import {buildExport,prepareDataToSendController,isEdit,readSpecificObjectFromCurrentData,doAjax,readSpecificKeyFromSearchCriteria,alterSearchCriteriForController,pushFilterSessionCacheState,retriveCriteriaObjectByOperation,isNew,isDeleteView,isOnlyLookupDataUpdate} from "../../utilities/filtersutil";
import {searchDropdown} from "./filter/searchDropdown.js";
import {actionOptions} from "./filter/actionOptions.js";
const _ = require("underscore");
import {keyDefaultFalseOption, isBlank} from '../../utilities/general';
let actionList = actionOptions;
const targetSelector = "#product-catalog-lookup";
import {handleCustomDropdownEvents} from "../../utilities/customBootstrapDropdowns";

let actionCellDropdownTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionCellDropdown.html');
let actionCellDropdownItemTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionCellDropdownItem.html');
let actionHeaderDropdownTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionHeaderDropdown.html');

run(targetSelector, ()=>{
  const dataTableComponentData =  $(targetSelector).data("items-data");
  const enrollmentType = $(targetSelector).data("enrollment-type");
  const editPermission = $(targetSelector).data("edit-permission");
  const viewItemRenderUrl =  $(targetSelector).data("view-item-render-url");
  const collateralDetailRenderUrl =  $(targetSelector).data("collateral-detail-render-url");
  const bundleDetailRenderUrl =  $(targetSelector).data("bundle-detail-render-url");
  const editItemRenderUrl =  $(targetSelector).data("edit-item-render-url");
  const addUpdateBundleURL =  $(targetSelector).data("edit-bundle-render-url");
  const addUpdateCollateralURL =  $(targetSelector).data("edit-collateral-render-url");
  const duplicateProductRenderUrl =  $(targetSelector).data("duplicate-product-render-url");
  const duplicateCollateralRenderUrl =  $(targetSelector).data("duplicate-collateral-render-url");
  const duplicateBundleRenderUrl =  $(targetSelector).data("duplicate-bundle-render-url");
  const deleteItemUrl =  $(targetSelector).data("delete-item-url");
  const activateItemUrl =  $(targetSelector).data("activate-item-url");
  const portletNamespace =  $(targetSelector).data("portlet-namespace");
  const filterItemsUrl =  $(targetSelector).data("filter-items-url");

  const generateExportUrl  =  $(targetSelector).data("generate-export-url");
  const shouldCheckCache  =  $(targetSelector).data("should-check-cache");
  const bulkActivateItemsUrl  =  $(targetSelector).data("bulk-activate-product-url");
  const bulkDeactivateItemsUrl  =  $(targetSelector).data("bulk-deactivate-product-url");
  const savedViews  =  $(targetSelector).data("saved-views");
  const saveViewURL  =  $(targetSelector).data("save-view-url");
  const deleteViewURL  =  $(targetSelector).data("delete-view-url");
  var disableCancel = "";

  let exportModal = new buildExport();
  var submitModalFlow = new SubmitModalFlow();
  submitModalFlow.init();
  const extraDetailForCacheFromServer  =  $(targetSelector).data("extra-detail-for-cache-from-server");
  const criteriaObjectFromServer  =  $(targetSelector).data("filter-criteria-from-server");
  let targetObject = "";
  let selectedRows = "";

  function createDetailLink(data, type, row){
    var returnString = "";
    var lowerPrdType = "";
    var prdType = "";
    if(row.product && row.product.prdType != null && row.product.prdType != 'null') {
    	lowerPrdType = row.product.prdType.toLowerCase();
    } else {
    	lowerPrdType = prdType;
    }
    let html = `<div class="q-marg-all-xs-at-md"><a href={%= bundleDetailRenderUrl %}&{%- portletNamespace%}itemId={%- itmId %} class='details-control anchor-text'>{%- data %}</a></div>`;
    if(lowerPrdType == "bundle"){
      returnString = render(
        html, {
          data: data,
          itmId: row.itmId,
          portletNamespace: portletNamespace,
          bundleDetailRenderUrl: bundleDetailRenderUrl
        }
      );
    }else if(lowerPrdType == "collateral"){
      returnString = render(
        html, {
          data: data,
          itmId: row.itmId,
          portletNamespace: portletNamespace,
          bundleDetailRenderUrl: collateralDetailRenderUrl
        }
      );
    }else {
      returnString = render(
        html, {
          data: data,
          itmId: row.itmId,
          portletNamespace: portletNamespace,
          bundleDetailRenderUrl: viewItemRenderUrl
        }
      );
    }
    return returnString;
  }

  if(shouldCheckCache){
	    targetObject = retriveCriteriaObjectByOperation(criteriaObjectFromServer,"like");
  }

  function renderDescription(data, type, item){
    let result;
    let html;
    if(item.itmActive){
      html = "<div class='q-marg-all-xs-at-md'>{%- data %}</div>";
      result = render(
        html, {
          data: data
        }
      );
    }else{
      html = "<div class='q-marg-all-xs-at-md inactive-items'>{%- data %}</div>";
      result = render(
        html, {
          data: data
        }
      );
    }
    return result;
  }

	function renderStatusPill(data, type, row){
		if(data === 'Active') {
			return "<div class='q-marg-all-xs-at-md q-pill q-pill-blue q-pill-table'>Active</div>";
		} else {
			return "<div class='q-marg-all-xs-at-md q-pill q-pill-blue-border q-pill-table'>Inactive</div>";
		}
	}

  var productLookup = new LookupTable({
    // REQUIRED - Set a target element
    target: $("#product-catalog-wrapper"),
    // Set a target class for min width, needs to be a "til-x" class so it doesn't interfere with mobile widths
    minWidthClass: "q-min-width-sm-til-md",
    // REQUIRED - Set which data should be visible for mobile
    mobileColumns: [
      {
        data: "itmSku",
        title: "Product (SKU)",
        render: createDetailLink
      },
      {
        data: "product.prdName",
        title: "Description",
        render: renderDescription,
        orderable:true,
      },
      {
        data: "itmStatus",
        title: "Status",
        render: renderStatusPill
      }
    ],
   // tableFilters: {
   //    data: orderFilterData,
   //  },

    // REQUIRED: search input info
    tableSearchInput: {
      // Not required
      // placeholder: 'Custom Search Text'
      value: (targetObject != "" ? targetObject.value[0] : "")

    },
    // REQUIRED - THIS IS TEMPORARY, WILL BE DEPRECATED WHEN WE ENABLE SEARCH INPUT ONLY
    tableSearchDropdown: {
	  selected: (targetObject == "" ? "" : targetObject.key),
      columns:searchDropdown
    },
    // OPTIONAL: Set Saved View Array
 		savedViews: savedViews,
 		bulkSelect: true,
    // REQUIRED - Data Table specific settings
    dataTable: {
	      // use same settings you would if you were just calling a dataTable normally
	    data: dataTableComponentData.content,
	      // Not required, just to show you can
	    columnDefs: [
	        { className: "custom-class", targets: [ 1 ] }
	    ],
	      // Not required, just to show you can
	    order: [
	        [7, 'asc'],
	    ],
	    columns: [
        {
          data: "itmStatus",
          render : renderActionWrap,
          orderable:false,
          class: 'dtc-action-column'
        },
        {
          data: "itmSku",
          title: "Product Name (SKU)",
          render: createDetailLink,
          class: 'dtc-min-width-md'
        },
        {
          data: "product.prdName",
          title: "Description",
          render: renderDescription,
 			    class: 'dtc-min-width-lg'
        },
        {
          data: "itmUpc",
          title: "UPC",
          class: 'dtc-min-width-sm'
        },
        {
          data: "product.category.catName",
          title: "Product Category",
          class: 'dtc-min-width-md'
        },
        {
          data: "product.prdType",
          title: "Product Type",
          class: 'dtc-min-width-sm product-type'
        },
        {
          data: "itmStatus",
          title: "Product Status",
          render: renderStatusPill,
          class: 'dtc-min-width-md'
        }
      ]
    },
    //  tableColumnModal: {
    	//	data: orderLookupColumnsPopup
  	//},
    paginationData:dataTableComponentData.page,
    filterModal: {
      // REQUIRED: Sets title of modal
      title: "Filter Products",
      // REQUIRED: Sets unique part of subtitle string.
      tableType: "products"
    },
	 	onBulkSelectChange: function() {
	    selectedRows = productLookup.getBulkSelectedData();
  	  $("th.dtc-action-column").html(renderActionHeaderWrap());
	    if (selectedRows.length >= 2) {
				$(".action-header-btn .base-btn").removeClass('disabled');
			}else{
			    $(".action-header-btn .base-btn").addClass('disabled');
			};
		},
    onFetch: function() {
      let currentData = productLookup.generateData();
      productLookup.showLoadingOverlay();

     	  //Withing lookup screen onFetch fun. can be called for different level of actions - like New view , Edit view, Delete view and Search, remove pills
      if(isOnlyLookupDataUpdate(currentData)){
        setTimeout(() => {
          doAjax({url: filterItemsUrl, success: filterSuccessFun, error: errorFun,data:prepareDataToSendController(currentData)});
        },SUCCESS_MODAL_TIMEOUT);
      }else if(isNew(currentData)){
        setTimeout(() => {
          doAjax({url: saveViewURL, success: savedViewSuccess, error: errorFun, data:prepareDataToSendController(currentData)});
        },SUCCESS_MODAL_TIMEOUT);
      }else if(isEdit(currentData)){
        setTimeout(() => {
          doAjax({url: saveViewURL, success: savedEditViewSuccess, error: errorFun, data:prepareDataToSendController(currentData)});
        },SUCCESS_MODAL_TIMEOUT);
      }else if(isDeleteView(currentData)){
        setTimeout(() => {
          doAjax({url: deleteViewURL, success: delteViewScussFun, error: errorFun, data:prepareDataToSendController(currentData)});
        },SUCCESS_MODAL_TIMEOUT);
      }
	  }
  });
  productLookup.init();
  var table = $("#product-catalog-wrapper .data-table-component").DataTable();
  /*if(table != null && enrollmentType === 'RMS'){
    table.columns('.product-type').visible( false );
    table.columns.adjust().draw( false ); // adjust column sizing and redraw
  }*/

	function filterSuccessFun(data){
		let items = data.content;
		let page = data.page;
		productLookup.setNewData(items);
		productLookup.setPaginationData(page)
		pushFilterSessionCacheState();
		productLookup.hideLoadingOverlay();
    setExportData(productLookup.generateData());
	}

	function savedViewSuccess(data){
    let items = data.lookupItems.content;
    let page = data.lookupItems.page;
    productLookup.setNewData(items);
    productLookup.setPaginationData(page);
    productLookup.setNewSavedViewData(data.savedView, "newSavedView");
  	pushFilterSessionCacheState();
    productLookup.hideLoadingOverlay();
    setExportData(productLookup.generateData());
	}

	function savedEditViewSuccess(data){
    let items = data.lookupItems.content;
    let page = data.lookupItems.page;
    productLookup.setNewData(items);
    productLookup.setPaginationData(page);
    productLookup.setNewSavedViewData(data.savedView, data.savedView.target);
  	pushFilterSessionCacheState();
    productLookup.hideLoadingOverlay();
    setExportData(productLookup.generateData());
	}

	function delteViewScussFun(data){
		let items = data.lookupItems.content;
	  let page = data.lookupItems.page;
		productLookup.removeSavedView(data.target);
		productLookup.setNewData(items);
	  productLookup.setPaginationData(page);
		productLookup.hideLoadingOverlay();
    setExportData(productLookup.generateData());
	}

	function errorFun(data){
    productLookup.hideLoadingOverlay();
	}

	function renderActionWrap(data, type, row, meta) {
	    let newRender;
	    let statusTarget = actionList["actions"];
      if(!editPermission){
        statusTarget = []; //make empty
      }
	    newRender = render(
	      actionCellDropdownTemplate, {
	        list: renderActionCellList(statusTarget,data,row),
	        index: meta.row
	      }
	    );
	    return newRender;
    };

    function renderActionHeaderWrap() {
  	  let statusTarget = actionList['all'];
      if(!editPermission){
        statusTarget = []; //make empty
      }
	    let newRender;
	    let data = "";
	    let row = "";
	    newRender = render(
	      actionHeaderDropdownTemplate, {
	        list: renderActionCellList(statusTarget,data,row)
	      }
	    );
	    return newRender;
    };

    function renderActionCellList(list,data,row) {
	    let renderedList = _(list).map((item)=>{
	      return render(
	        actionCellDropdownItemTemplate, neededActions(data, row, item)
	      )
   		 });
	    return renderedList.join('');
    };

    function neededActions(data, row, item){
      var action = {};
      if(item.title === 'Activate/Deactivate'){
        if(data === "Active"){
          action = {
            icon: 'toggle-off',
            title: 'Deactivate',
            cls: "deactivate-product",
            disabled: false
          };
        }else{
          action = {
            icon: 'toggle-on',
            title: 'Activate',
            cls: "activate-product",
            disabled: false
          };
        }
      }else if(item.title === 'Duplicate'){
        if(row.product != null && row.product.prdHazardMaterial){
          action = {
            icon: 'clone',
            title: 'Duplicate',
            cls: "",
            disabled: true
          };
        }else{
          action = {
            icon: 'clone',
            title: 'Duplicate',
            cls: "duplicate-product",
            disabled: false
          };
        }
      }else if(item.title === 'Activate Selected Products'){
        action = {
          icon: item.icon,
          title: item.title,
          cls: item.cls,
          disabled: checkDisableForGivenAction(data, row, item.title)
        };
      }else if(item.title === 'Deactivate Selected Products'){
        action = {
          icon: item.icon,
          title: item.title,
          cls: item.cls,
          disabled: checkDisableForGivenAction(data, row, item.title)
        };
      }else{
        action = {
          icon: item.icon,
          title: item.title,
          cls: item.cls,
          disabled: item.disabled
        };
      }
      return action;
    }

	function checkDisableForGivenAction(data, row, actionName) {
    let isTrue = false;
    _(selectedRows).map((item)=>{
      if(callBusinessLogicToDisableAction(item.data.itmStatus, item.data, actionName)){
    	  if (!isTrue){
      		isTrue = true;
      	}
      }
    });
    return isTrue;
	};

	function callBusinessLogicToDisableAction(data, row, actionName) {
		if (editPermission && isPresent(data)) {
			if(actionName === "Activate Selected Products"){
				if(data === "Active") {
					return true;
				}else{
					return false;
				}
			}
			else if(actionName === "Deactivate Selected Products"){
				if (data === "Inactive") {
					return true
				}else{
					return false;
				}
			}
		}
	}


  $('body').on( 'click', '.edit-product', function (e) {
    e.preventDefault();
    let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
		// Get the row based on the parent...
		let parent = $(".dropdown-parent-" + pIndex).parents('tr');
    // Get the row data
    let row = table.row(parent);
    var item = row.data();
    var productdType = item.product.prdType;
    if(productdType != 'undefined' && productdType != null && productdType != 'null') {
	    if(productdType.toLowerCase() == "bundle")
	    {
	      	location.href = `${addUpdateBundleURL}&${portletNamespace}itemId=${item.itmId}`;
	    }
	    else if(productdType.toLowerCase() == "collateral") {
		    location.href = `${addUpdateCollateralURL}&${portletNamespace}itemId=${item.itmId}`;
	    }
	    else{
	      	location.href = `${editItemRenderUrl}&${portletNamespace}itemId=${item.itmId}`;
	    }
    }
    else{
      	location.href = `${editItemRenderUrl}&${portletNamespace}itemId=${item.itmId}`;
    }
  });

  $('body').on( 'click', '.duplicate-product', function (e) {
    e.preventDefault();
    let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
		// Get the row based on the parent...
		let parent = $(".dropdown-parent-" + pIndex).parents('tr');
    // Get the row data
    let row = table.row(parent);
    var item = row.data();
    var productdType = item.product.prdType;
	  if(productdType != 'undefined' && productdType != null && productdType != 'null') {
      if(productdType.toLowerCase() == "bundle"){
        location.href = `${duplicateBundleRenderUrl}&${portletNamespace}itemId=${item.itmId}`;  
      }else if(productdType.toLowerCase() == "collateral") {
        location.href = `${duplicateCollateralRenderUrl}&${portletNamespace}itemId=${item.itmId}`;
      }else{
        location.href = `${duplicateProductRenderUrl}&${portletNamespace}itemId=${item.itmId}`;
      }
    }else{
    	location.href = `${duplicateProductRenderUrl}&${portletNamespace}itemId=${item.itmId}`;
    }
  });

  $('body').on( 'click', '.deactivate-product', function (e) {
    e.preventDefault();
    let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
		// Get the row based on the parent...
		let parent = $(".dropdown-parent-" + pIndex).parents('tr');
    // Get the row data
    let row = table.row(parent);
    var submitModalFlow = new SubmitModalFlow({
      confirmModalTitle: 'Deactivate Product',
      confirmModalBody: '<div class="q-pad-all-xl">Once this product is deactivated, orders containing this product won’t be fulfilled and this product cannot be added to inbound shipments.</div>',
      confirmModalBtnText: 'Deactivate Product',
      onConfirmClick: function() {
        submitModalFlow.showLoadingModal();
        deleteProduct(row, row.data());
        function deleteProduct(row, item) {
          $.ajax({
            url: deleteItemUrl,
            type: 'POST',
            dataType: 'JSON',
            data: {
              [`${portletNamespace}itemId`]: item.itmId
            },
            success: function(data){
              if(data.response == "success") {
                var d = row.data();
                d.itmSku=$.trim(data.itmSku);
                d.itemAttributes=$.trim(data.itemAttributes);
                d.itmActive=data.itmActive;
                d.itmStatus=$.trim(data.itmStatus);
                row.data(d).draw();
                submitModalFlow.showSuccessModal();
                setTimeout(function() {
                  submitModalFlow.hideAllModals();
                }, window.constants.SUCCESS_MODAL_TIMEOUT);
              }else{
                submitModalFlow.showFailureModal();
              }
            },
            error: function(data){
              submitModalFlow.hideAllModals();
            }
          });
        };
      }
    });
    submitModalFlow.init();
    submitModalFlow.showConfirmModal();
  });

  $('body').on( 'click', '.activate-product', function (e) {
    e.preventDefault();
    let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
		// Get the row based on the parent...
		let parent = $(".dropdown-parent-" + pIndex).parents('tr');
    // Get the row data
    let row = table.row(parent);
    var submitModalFlow = new SubmitModalFlow({
      confirmModalTitle: 'Activate Product',
      confirmModalBody: '<div class="q-pad-all-xl">Once this product is activated, orders can be fulfilled with this product and inbound shipments can contain this product.</div>',
      confirmModalBtnText: 'Activate Product',
      onConfirmClick: function() {
        submitModalFlow.showLoadingModal();
        activateProduct(row, row.data());
        function activateProduct(row, item) {
          $.ajax({
            url: activateItemUrl,
            type: 'POST',
            dataType: 'JSON',
            data: {
              [`${portletNamespace}itemId`]: item.itmId
            },
            success: function(data){
              if(data.response == "success") {
                var d = row.data();
                d.itmSku=$.trim(data.itmSku);
                d.itemAttributes=$.trim(data.itemAttributes);
                d.itmActive=data.itmActive;
                d.itmStatus=$.trim(data.itmStatus);
                row.data(d).draw();
                submitModalFlow.showSuccessModal();
                setTimeout(function() {
                  submitModalFlow.hideAllModals();
                }, window.constants.SUCCESS_MODAL_TIMEOUT);
              }else{
                submitModalFlow.showFailureModal();
              }
            },
            error: function(data){
              submitModalFlow.hideAllModals();
            }
          });
        };
      }
    });
    submitModalFlow.init();
    submitModalFlow.showConfirmModal();
  });

	$('body').on('click', '.bulk-activate-product', function(e) {
		e.preventDefault();
		if(shallAllowClick(this)){
      var submitModalFlow = new SubmitModalFlow({
        confirmModalTitle: 'Activate Products',
        confirmModalBody: '<div class="q-pad-all-xl">Once these products are activated, orders can be fulfilled with these products and inbound shipments can contain these products.</div>',
        confirmModalBtnText: 'Activate Products',
        onConfirmClick: function() {
          submitModalFlow.showLoadingModal();
          activateProducts();
          function activateProducts() {
            $.ajax({
              url: bulkActivateItemsUrl,
              type: 'POST',
              dataType: 'JSON',
              data: {
                [`${portletNamespace}itemIds`]: getAllSelectedItemIds()
              },
              success: function(data){
                if(data.response == "success") {
                  _(selectedRows).map((item)=>{
       	      	    let currentRow =  table.row(item.rowIndex)
       	     	      var d = currentRow.data();
                    d.itmActive = true;
                    d.itmStatus = "Active";
                    d.itmArchived = false;
       		          currentRow.data(d).draw();
       	    	    });
                  productLookup.uncheckAllSelected();
                  submitModalFlow.showSuccessModal();
                  setTimeout(function() {
                    submitModalFlow.hideAllModals();
                  }, window.constants.SUCCESS_MODAL_TIMEOUT);
                }else{
                  submitModalFlow.showFailureModal();
                }
              },
              error: function(data){
                submitModalFlow.hideAllModals();
              }
            });
          }
        }
      });
      submitModalFlow.init();
      submitModalFlow.showConfirmModal();
		}
	});

  $('body').on( 'click', '.bulk-deactivate-product', function (e) {
    e.preventDefault();
    if(shallAllowClick(this)){
      var submitModalFlow = new SubmitModalFlow({
        confirmModalTitle: 'Deactivate Products',
        confirmModalBody: '<div class="q-pad-all-xl">Once these products are deactivated, orders containing these products won’t be fulfilled and these products cannot be added to inbound shipments.</div>',
        confirmModalBtnText: 'Deactivate Products',
        onConfirmClick: function() {
          submitModalFlow.showLoadingModal();
          deactivateProducts();
          function deactivateProducts() {
            $.ajax({
              url: bulkDeactivateItemsUrl,
              type: 'POST',
              dataType: 'JSON',
              data: {
                [`${portletNamespace}itemIds`]: getAllSelectedItemIds()
              },
              success: function(data){
                if(data.response == "success") {
                  _(selectedRows).map((item)=>{
       	      	    let currentRow =  table.row(item.rowIndex)
       	     	      var d = currentRow.data();
                    d.itmActive = false;
                    d.itmStatus = "Inactive";
                    d.itmArchived = true;
       		          currentRow.data(d).draw();
       	    	    });
                  productLookup.uncheckAllSelected();
                  submitModalFlow.showSuccessModal();
                  setTimeout(function() {
                    submitModalFlow.hideAllModals();
                  }, window.constants.SUCCESS_MODAL_TIMEOUT);
                }else{
                  submitModalFlow.showFailureModal();
                }
              },
              error: function(data){
                submitModalFlow.hideAllModals();
              }
            });
          }
        }
      });
      submitModalFlow.init();
      submitModalFlow.showConfirmModal();
    }
  });

  function shallAllowClick(currentObj){
 		return 	!($(currentObj).hasClass("disabled"));
  }

	function getAllSelectedItemIds(){
		var itemIds = new Array();
		_(selectedRows).map((item)=>{
			itemIds.push(item.data.itmId);
		 });
		return itemIds;
	}

  function initExport() {
		let exportObj  =  {
      title : 'Export Product Catalog',
      exportAttemptTextPart1Lang: 'You\'re attempting to export',
      exportAttemptTextPart2Lang: 'row(s). Please select a file format below.',
      exportMaxLimitLang: 'A maximum of 1000 rows can be exported.'
		};
		exportModal.init(exportObj);
		exportModal.bindExportEvent();
	}

	function setExportData(currentData) {
		exportModal.buildExportBasicURL(generateExportUrl,currentData);
		exportModal.setExportCount(currentData.totalElements);
	}

	initExport();
	setExportData(productLookup.generateData());

  // Allow custom dropdowns to work (based on class 'overflow-dropdown'), check the template for more information;
	handleCustomDropdownEvents();

  $("th.dtc-action-column").html(renderActionHeaderWrap());
});



// WEBPACK FOOTER //
// ./src/pages/products/lookup.js